import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import * as yup from 'yup'

import Checkbox from '../../Form/Checkbox/Checkbox'
import { useFlag } from '../../FeatureFlag/use-flag'

import './DeliveryCommunicationConsent.css'

export const Component = ({ cart }) => {
  const daasIntegrationFlag = useFlag('oo-daas-integration', false)

  if (!daasIntegrationFlag) {
    return null
  }

  return cart &&
    cart.deliveryProviderInfo &&
    cart.deliveryProviderInfo.needsDeliveryCommunicationConsent &&
    (
      <div styleName='delivery-communication-consent'>
        <Field
          id='delivery_communication_consent_given'
          component={Checkbox}
          name='deliveryCommunicationConsentGiven'
          label={<span>Yes, I want to receive text updates</span>}
        />
        <p>
          You agree that we and our delivery partners, including DoorDash,
          may send you automated text messages and calls to update you on your
          order status, using the phone number you have on file with us.
          Standard text and data rates apply. <a href='https://pos.toasttab.com/privacy' rel='noopener noreferrer' target='_blank'>Learn more</a>
        </p>
      </div>
    )
}

Component.displayName = 'DeliveryCommunicationConsent'
Component.propTypes = {
  cart: PropTypes.object.isRequired
}

export const getInitialValues = ({
  cart,
  featureFlags
}) => {
  if (!featureFlags['oo-daas-integration']) return null

  if (!cart || !cart.deliveryProviderInfo || !cart.deliveryProviderInfo.needsDeliveryCommunicationConsent) {
    return null
  }

  return { deliveryCommunicationConsentGiven: true }
}

export const getValidationSchema = ({
  cart,
  featureFlags
}) => {
  if (!featureFlags['oo-daas-integration']) return null

  if (!cart || !cart.deliveryProviderInfo || !cart.deliveryProviderInfo.needsDeliveryCommunicationConsent) {
    return null
  }

  return {
    deliveryCommunicationConsentGiven: yup.boolean()
      .default(true)
  }
}

export const getArgsForSubmit = ({
  values,
  cart,
  featureFlags
}) => {
  if (!featureFlags['oo-daas-integration']) return null

  if (!cart || !cart.deliveryProviderInfo || !cart.deliveryProviderInfo.needsDeliveryCommunicationConsent) {
    return null
  }

  return {
    deliveryCommunicationConsentGiven: values.deliveryCommunicationConsentGiven
  }
}
